/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Account } from './account';
import { Asset } from './asset';

export interface VenueTransferRoute {
  id?: number;
  sourceVenue?: VenueTransferRoute.SourceVenueEnum;
  sourceAccountId?: number;
  sourceAccount?: Account;
  destinationVenue?: VenueTransferRoute.DestinationVenueEnum;
  destinationAccountId?: number;
  destinationAccount?: Account;
  assetId?: number;
  asset?: Asset;
  network?: string;
  sourceNetworkCode?: string;
  sourceAddress?: string;
  destinationAddress?: string;
  memo?: string;
  sourceDestinationRef?: string;
  active?: boolean;
}
export namespace VenueTransferRoute {
  export const SourceVenueEnum = {
    Kraken: 'KRAKEN',
    Okx: 'OKX',
    Zerohash: 'ZEROHASH',
    CustomersBank: 'CUSTOMERS_BANK',
    Fireblocks: 'FIREBLOCKS',
  } as const;
  export type SourceVenueEnum = (typeof SourceVenueEnum)[keyof typeof SourceVenueEnum];
  export const DestinationVenueEnum = {
    Kraken: 'KRAKEN',
    Okx: 'OKX',
    Zerohash: 'ZEROHASH',
    CustomersBank: 'CUSTOMERS_BANK',
    Fireblocks: 'FIREBLOCKS',
  } as const;
  export type DestinationVenueEnum = (typeof DestinationVenueEnum)[keyof typeof DestinationVenueEnum];
}
